import React from 'react';
import jsCookie from 'js-cookie';
import { COOKIES, ENVIRONMENT } from '../constants';
import AdsProfileForm from '../components/AdsProfileForm';
import Layout from '../components/Layout';
import getEnvVariable from '../utils/environment';


class AdsProfile extends React.Component {
  componentWillMount() {
    if (!jsCookie(COOKIES.MAKO_AUTH)) {
      window.location.replace(`${getEnvVariable(ENVIRONMENT.MAKO_URL)}/login?redirect_to=%2Fsignup%2Fads%2Faccount_details`);
    }
  }

  render() {
    return (
      <Layout
        title=""
      >
        <AdsProfileForm />
      </Layout>
    );
  }
}

export default AdsProfile;



// WEBPACK FOOTER //
// ./src/pages/AdsProfile.jsx